import React, { useState } from 'react'
import { Link } from 'react-router-dom'
// CSS
import '../assets/css/footer.css'

export default function Footer() {

  const [year, setyear] = useState(new Date().getFullYear());

  return (
    <footer>
      <div className='container'>
        <div className='footer_content'>
          <div className='left'>
            <div className='section about'>
              <div className='section_content'>
                <img src={require('../assets/images/branding.png')} alt='Logo' />
                <p>We are the Software Development and Digital Marketing agency providing Web Development, App Development, Digital Marketing and other IT solution services.</p>
                <div className='actions'>
                  <Link to='/about#about' className='btn'>Know About Us</Link>
                </div>
              </div>
            </div>
  
            <div className='section quick_links'>
              <div className='section_header'>
                <h2>Quick Links</h2>
              </div>
  
              <div className='section_content'>
                <ul>
                  <li><Link to='/about'>About</Link></li>
                  <li><Link to='/services'>Services</Link></li>
                  <li><Link to='/portfolio'>Portfolio</Link></li>
                  <li><Link to='/contact'>Contact</Link></li>
                </ul>
              </div>
            </div>
          </div>
          
          <div className='right'>
            <div className='section contact'>
              <div className='section_header'>
                <h2>Contact</h2>
              </div>
              <div className='section_content'>
                <div className='item'>
                  <div className='icon'>
                    <i className="fa-solid fa-phone"></i>
                  </div>
                  <div className='details'>
                    <p>+91-958-958-958</p>
                  </div>
                </div>
  
                <div className='item'>
                  <div className='icon'>
                    <i className="fa-solid fa-envelope"></i>
                  </div>
                  <div className='details'>
                    <a href='mailto:hovsofts@gmail.com'>hovsofts@gmail.com</a>
                  </div>
                </div>
              </div>
            </div>
  
            <div className='section social_links'>
              <div className='section_header'>
                <h2>Social Links</h2>
              </div>
              <div className='section_content'>
                <ul className='links'>
                  <li><a href='#'>Facebook</a></li>
                  <li><a href='#'>Twitter</a></li>
                  <li><a href='#'>Instagram</a></li>
                  <li><a href='#'>Linkedin</a></li>
                </ul>
                
                <div className='image'>
                  <img src={require('../assets/images/hovered.png')} alt='Logo' />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='footer_bottom'>
          <p className='copyright'>Copyright &copy; {year} HovSofts<br /><span>All rights reserved.</span></p>
        </div>
      </div>
    </footer>
  )
}
